"use client";

import {memo} from "react";
import {NavDropdownListProps} from "./MobileMenu/MenuTypes";
import NavDropdownItemWithChildren from "./NavDropdownItemWithChildren";
import NavDropdownSubmenu from "./NavDropdownSubmenu";
import Link from "next/link";
import staticUrls from "@/app/util/staticPageUrls";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowRight} from "@fortawesome/sharp-solid-svg-icons/faArrowRight";
import clsMerge from "@/app/util/clsMerge";
import {navDropdownElementClasses} from "./navElementClasses";
import NavLocation, {NavLocationVariants} from "./NavLocation";
import Campus from "@/app/types/Campus";
import {useRedirectToCurrentPage} from "@/app/util/useRedirectToCurrentPage";

interface CampusNavItemProps extends Omit<NavDropdownListProps, "classes"> {
	campus: Campus | null;
	isFetchingCampus: boolean;
}

const CampusNavItem: React.FC<CampusNavItemProps> = ({
	menuItems,
	campus,
	isFetchingCampus,
	isOpen,
	...props
}) => {
	const findCampusHref = useRedirectToCurrentPage(staticUrls.location);
	if (!props) {
		return null;
	}
	return (
		<NavDropdownItemWithChildren
			classes={{
				root: "w-30 justify-end",
				labelRoot: "px-3",
				dialog: "p-0 pb-0 overflow-hidden max-w-96",
				overlayArrow: "fill-gray-50 stroke-gray-50",
			}}
			hasChevron={false}
			isOpen={!isFetchingCampus && isOpen}
			{...props}
		>
			<NavLocation
				data={campus}
				variant={NavLocationVariants.light}
				classes={{
					overviewRoot: "hidden",
					detailsRoot: "text-sm w-full text-gray-900 px-8",
				}}
			/>
			<NavDropdownSubmenu menuItems={menuItems} classes={{listItems: "px-8"}} />
			<div>
				<Link
					href={findCampusHref}
					className={clsMerge(
						navDropdownElementClasses,
						"transition-color flex w-full flex-row items-center justify-center gap-2 bg-dark-navy px-4 py-2 text-white hover:bg-navy-800"
					)}
				>
					Find Another Campus <FontAwesomeIcon icon={faArrowRight} />
				</Link>
			</div>
		</NavDropdownItemWithChildren>
	);
};

export default memo(CampusNavItem);
